import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=0a181dc0"
import script from "./LeftSidebar.vue?vue&type=script&lang=ts"
export * from "./LeftSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports